module.exports = __webpack_public_path__ + "static/media/play@3x.7076573f.png";